var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 873,
    height: 592,
    viewBox: "0 0 873 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70831 41.0735C7.51483 70.0338 -0.216206 493.039 8.9874 583.015C26.5579 582.456 56.5794 584.133 74.1499 583.015L78.2606 554.292L88.8434 583.015C172.513 580.221 257.391 584.291 341.897 583.174L350.186 568.761L357.664 583.174C478.148 582.056 655.992 580.184 775.639 582.978C806.741 582.978 825.842 582.978 849.02 582.978C852.366 577.39 849.379 141.094 849.38 41.804C810.892 40.4374 720.005 40.2083 681.517 41.326L670.64 53.6207L660.6 48.0322L652.233 49.1499L645.539 41.8848C520.035 44.6791 395.368 44.1202 270.7 41.3259L263.17 50.8264L251.456 46.3556L242.253 59.7681L236.226 41.3259C183.306 41.3259 131.442 43.8678 80.404 41.0735C53.0721 39.5771 60.3008 41.0735 8.70831 41.0735Z",
    fill: "url(#paint0_linear_329_4007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3305 28.9457L29.8494 56.1888C35.6217 52.7834 41.6346 47.6753 42.8371 37.4592C43.3182 34.0538 43.0776 30.0808 42.1156 26.1079C40.6725 19.2971 37.0648 10.2161 30.571 0L30.3305 28.9457Z",
    fill: "url(#paint1_linear_329_4007)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70952 48.2429C1.70952 49.378 1.70954 50.5131 1.46903 51.0807C2.43108 57.8914 12.7731 61.2968 18.7859 59.5941C20.229 59.0266 25.0393 58.459 29.8495 55.6212L30.3306 28.3781C13.2542 33.4862 2.91208 43.1348 1.70952 48.2429Z",
    fill: "url(#paint2_linear_329_4007)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.09 56.1891C25.2797 59.027 20.4694 59.5945 19.0264 60.1621C13.0135 61.8648 2.67149 58.4594 1.70944 51.6486C-5.50595 194.107 12.292 559.05 14.9376 568.131C23.5961 599.915 40.6725 578.347 41.1536 561.888C40.9131 557.915 40.6725 553.942 40.432 549.969C21.4315 219.647 43.0776 37.4595 43.0776 37.4595C41.8751 47.6757 35.8623 53.3513 30.09 56.1891Z",
    fill: "url(#paint3_linear_329_4007)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M859.972 35.9457L859.491 63.1888C865.263 59.7834 871.276 54.6753 872.478 44.4592C872.959 41.0538 872.719 37.0808 871.757 33.1079C870.314 26.2971 866.706 17.2161 860.212 7L859.972 35.9457Z",
    fill: "url(#paint4_linear_329_4007)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M831.351 55.2429C831.351 56.378 831.351 57.5131 831.11 58.0807C832.072 64.8914 842.414 68.2968 848.427 66.5941C849.87 66.0266 854.68 65.459 859.491 62.6212L859.972 35.3781C842.895 40.4862 832.553 50.1348 831.351 55.2429Z",
    fill: "url(#paint5_linear_329_4007)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M859.731 63.1891C854.921 66.027 850.111 66.5945 848.667 67.1621C842.655 68.8648 832.313 65.4594 831.351 58.6486C824.135 201.107 841.933 566.05 844.579 575.131C853.237 606.915 870.314 585.347 870.795 568.888C870.554 564.915 870.314 560.942 870.073 556.969C851.073 226.647 872.719 44.4595 872.719 44.4595C871.516 54.6757 865.503 60.3513 859.731 63.1891Z",
    fill: "url(#paint6_linear_329_4007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_4007",
    x1: 9.21516,
    y1: 308.896,
    x2: 803.254,
    y2: 308.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4B492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_329_4007",
    x1: 40.7365,
    y1: 62.4785,
    x2: 11.1638,
    y2: 37.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671642,
    stopColor: "#A86628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1903,
    stopColor: "#C79C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#D9BCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4179,
    stopColor: "#E5D0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5933,
    stopColor: "#F3E9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_329_4007",
    x1: 12.8915,
    y1: 22.4238,
    x2: 47.7787,
    y2: 58.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671642,
    stopColor: "#8C4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_329_4007",
    x1: 39.0731,
    y1: 311.057,
    x2: 0.325837,
    y2: 311.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    stopColor: "#F9F3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4515,
    stopColor: "#F3E6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#EDD9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E3C6AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8321,
    stopColor: "#DAB38E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    stopColor: "#CC9766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_329_4007",
    x1: 870.378,
    y1: 69.4785,
    x2: 840.805,
    y2: 44.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671642,
    stopColor: "#A86628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1903,
    stopColor: "#C79C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#D9BCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4179,
    stopColor: "#E5D0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5933,
    stopColor: "#F3E9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_329_4007",
    x1: 842.533,
    y1: 29.4238,
    x2: 877.42,
    y2: 65.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671642,
    stopColor: "#8C4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_329_4007",
    x1: 868.714,
    y1: 318.057,
    x2: 829.967,
    y2: 318.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    stopColor: "#F9F3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4515,
    stopColor: "#F3E6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#EDD9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E3C6AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8321,
    stopColor: "#DAB38E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    stopColor: "#CC9766"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.12783cccbed7231304ab782a0dd849a2.svg";
export { ForwardRef as ReactComponent };